(() => {
  if (customElements.get('nlx-newsletter-popup')) return;
  customElements.define('nlx-newsletter-popup', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      const params = new URLSearchParams(window.location.search);
      this.preview = params.get('nlx_newsletter_preview') === '1' || this.dataset.editor === 'true';
      if (this.dataset.enabled !== 'true' && !this.preview) return;
      this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('nlx-welcome-lock');
        if (!this.preview) this.write('nlx-welcome-dismissed', Date.now());
      });
      if (this.preview) {
        this.show();
        return;
      }
      if (this.read('nlx-welcome-submitted') || Date.now() - this.read('nlx-welcome-dismissed') < 7 * 86400000) return;
      // Let visitors browse first, and avoid interrupting other store dialogs.
      this.timer = window.setTimeout(() => {
        const anotherDialogIsVisible = [...document.querySelectorAll('dialog[open],details[open].menu-opening,[aria-modal="true"]')].some(element =>
          element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden' && getComputedStyle(element).display !== 'none'
        );
        if (document.visibilityState !== 'visible' || anotherDialogIsVisible) return;
        this.show();
      }, Number(this.dataset.delay || 12) * 1000);
    }
    read(key) { try { return Number(localStorage.getItem(key)) || 0; } catch { return 0; } }
    write(key, value) { try { localStorage.setItem(key, String(value)); } catch { /* The signup also works without browser storage. */ } }
    show() {
      if (!this.isConnected || this.dialog.open) return;
      this.dialog.showModal();
      document.documentElement.classList.add('nlx-welcome-lock');
      this.querySelector('[data-close]').focus();
    }
    disconnectedCallback() {
      window.clearTimeout(this.timer);
      if (this.dialog?.open) this.dialog.close();
      document.documentElement.classList.remove('nlx-welcome-lock');
    }
  });
})();
